module.exports = __webpack_public_path__ + "img/1.6becad35.png";